<app-content-modal [buttons]="exampleFormButtons" [hideClose]="true" (closeModal)="close()">
  <article class="animated fadeIn">
    <h1>{{ 'MULTIMEDIA_FORM.TITLE' | translate }}</h1>
    <app-example-form (submitExample)="createExample($event)" (formChanges)="updateValidation()"> </app-example-form>
  </article>
</app-content-modal>
